// Copyright (c) 2016 Deere & Company

import KeyValuePair from '@deere/cps-it.warranty-model-factory/lib/key-value-pair';
import t from 'tcomb';

const CreateClaimModal = t.struct({
    claimTypes: t.list(KeyValuePair, 'ClaimTypes'),
    isModalOpen: t.Boolean,
    mode: t.String,
    selectedPin: t.String
}, 'CreateClaimModal');

export const getDefaultState = () => new CreateClaimModal({
    claimTypes: [],
    isModalOpen: false,
    mode: '',
    selectedPin: ''
});

export default CreateClaimModal;



// WEBPACK FOOTER //
// ./src/shared/state/create-claim-modal.js